import cn from 'classnames';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { useMemo } from 'react';

import history from '../../../utils/history';

import { ArrowCaret } from '../../icons/analytics';
import { PAGE_LAYOUT_NAVIGATION_PANEL_SET_SECTIONS } from '../../../store/reducers/pageLayout';

import styles from './NavigationPanel.module.scss';
import { useMixpanel } from 'react-mixpanel-browser';
import { reportBusinessActionToMixpanel } from '../../../utils/reportBusinessActionToMixpanel';

export function NavigationPanelTitle({ prefix, item, isCollapsible = false, className = '', path = false }) {
  const { name: supplierName } = useSelector((state) => state.role.supplier);
  const dispatch = useDispatch();
  const mixpanel = useMixpanel();
  const reportBi = () => {
    reportBusinessActionToMixpanel(mixpanel, `left-bar-menu-${item.title}`, { supplierName });
  };

  const title = useMemo(() => {
    let title = <span className={styles.linkTitle}>{item.title}</span>;
    if (item.icon) {
      title = (
        <>
          <span className={styles.linkIcon}>{item.icon}</span>
          {title}
        </>
      );
    }

    if (isCollapsible) {
      title = (
        <>
          {title}
          <span className={cn(styles.collapsibleIcon)}>
            <ArrowCaret />
          </span>
        </>
      );
    }

    const href = prefix + item.link;
    return item.link ? (
      <a href={href} onClick={(event) => goto(event, href, item.title.toLowerCase())} className={styles.titleWrapper}>
        {title}
      </a>
    ) : (
      <span className={styles.titleWrapper}>{title}</span>
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item, prefix, isCollapsible]);

  const itemTitleOnClick = (itemTitle) => {
    dispatch({
      type: PAGE_LAYOUT_NAVIGATION_PANEL_SET_SECTIONS,
      payload: { sectionPath: `${path}.${itemTitle.toLowerCase()}` },
    });
  };

  const goto = (event, href, title) => {
    reportBi();
    itemTitleOnClick(title.toLowerCase());
    history.push(href);
    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  return (
    <div className={cn(styles.itemTitle, className)} onClick={() => itemTitleOnClick(item.title.toLowerCase())}>
      {title}
    </div>
  );
}

NavigationPanelTitle.propTypes = {
  prefix: PropTypes.string.isRequired,
  item: PropTypes.object.isRequired,
  isCollapsible: PropTypes.bool,
  className: PropTypes.string,
  path: PropTypes.string,
};
